import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { Link } from 'react-router-dom'
import Loader from 'react-js-loader'
import admindata from '../../components/admindata'
import Swal from 'sweetalert2'
import { apiRequest } from '../../apiServices/allApi'
import AgentHistory from './AgentHistory'
const $ = require('jquery')
$.Datatable = require('datatables.net')

const SucWithdraw = () => {
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState()
 const id = localStorage.getItem('id')


  let [limit, setLimit] = useState(20)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
  //user for searching..
  const [searchList, setSearchList] = useState(0)
  const [searchType, setSearchType] = useState("Phone")
  const [findByStatus, setFindByStatus] = useState(0)

  //react paginate..
  const handlePageClick = async data => {
    let currentPage = data?.selected + 1
    setPageNumber(currentPage)
    // scroll to the top
    //window.scrollTo(0, 0)
  }

  //   searching handler
  const searchHandler = event => {
    let key = event.target.value
    setSearchList(key)
  }
  //   search by status handler
  const searchByStatus = event => {
    setSearchType("0")
    let key = event.target.value
    setFindByStatus(key)
  }

  // const profle = () => {
  //   // setLoading(true)
  //   // Swal.showLoading(Swal.getDenyButton())
  //   const access_token = localStorage.getItem('token')
  //   const headers = {
  //     Authorization: `Bearer ${access_token}`
  //   }
  //   axios
  //     .get(
  //       baseUrl +
  //         `admin/txn/withdraw_admin/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}`,
  //       { headers }
  //     )
  //     .then(res => {
  //       setUser(res.data?.data)
  //       setNumberOfPages(res.data?.totalPages)
  //       // Swal.hideLoading( {timer: 1500})
  //       // setLoading(false)
  //     })
  // }


  const profle = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
  try {
    const res = await apiRequest(`admin/txn/withdraw_admin/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}`,"GET",null,headers);
    setUser(res.data?.data)
      setNumberOfPages(res.data?.totalPages)
  } catch (error) {
  //  console.log(error)
  } finally {
    // setLoading(false)
  }
}

  const [withdrawSuccess, setWithdrawSuccess] = useState()
  const [withdrawFail, setWithdrawFail] = useState()

  // const withdrowPass = id => {
  //   const confirm = window.confirm(
  //     'Are you sure, you want to update to success this payout?'
  //   )
  //   if (confirm) {
  //     const access_token = localStorage.getItem('token')
  //     const headers = {
  //       Authorization: `Bearer ${access_token}`
  //     }

  //     axios
  //       .post(
  //         baseUrl + `userwithdrawupdate/${id}`,
  //         {
  //           status: 'SUCCESS'
  //         },
  //         { headers }
  //       )
  //       .then(res => {
  //         profle()
  //         alert('Payout successfully done')
  //       })
  //       .catch(e => {
  //         //console.log(e);
  //       })
  //   }
  // }

  const withdrowPass = async (id) => {
    const confirm = window.confirm(
      'Are you sure, you want to update to success this payout?'
    )
    if (confirm) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }
  try {
    const res = await apiRequest(`userwithdrawupdate/${id}`,"POST",
          {
            status: 'SUCCESS'
          },headers)
          profle()
          alert('Payout successfully done')
  } catch (e) {
     console.log(e);
  } finally {
    // setLoading(false)
  }
}
  

  // const withdrowFail = id => {
  //   const confirm = window.confirm(
  //     'Are you sure, you want to update to failed this payout?'
  //   )
  //   if (confirm) {
  //     const access_token = localStorage.getItem('token')
  //     const headers = {
  //       Authorization: `Bearer ${access_token}`
  //     }

  //     axios
  //       .post(
  //         baseUrl + `userwithdrawupdate/${id}`,
  //         {
  //           status: 'FAILED'
  //         },
  //         { headers }
  //       )
  //       .then(res => {
  //         profle()
  //         alert('Payout successfully reject')
  //         //console.log(res);
  //       })
  //       .catch(e => {
  //         //console.log(e);
  //       })
  //   }
  // }

  const withdrowFail = async (id) => {
    const confirm = window.confirm(
      'Are you sure, you want to update to failed this payout?'
    )
    if (confirm) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }
  try {
    const res = await apiRequest( `userwithdrawupdate/${id}`,"POST",
      {
        status: 'FAILED'
      },headers)
      profle()
      alert('Payout successfully reject')
  } catch (e) {
     console.log(e);
  } finally {
    // setLoading(false)
  }
}
  }}

  const universalCheckPayout = (payment_gatway, txn_id, referenceId, userID) => {
    //alert(payment_gatway);
    if (!referenceId) {
      alert('Payout txn id not found')
    }
    if (payment_gatway == 'razorpay') {
      checkrazorpaypayout(txn_id, referenceId)
    }
    else if(payment_gatway == 'MYPAY'){
      checkMyPayPayment(txn_id,referenceId)
    } else if (payment_gatway == 'qrologic') {
      checkqrologic(txn_id, referenceId, userID)
    } else if (payment_gatway == 'pinelab') {
      //checkPinelabpayout(txn_id, referenceId)
    } else {
      alert('Nothing found')
    }
  }


  // const checkqrologic = (txn_id, referenceId, userID) => {
  //   const access_token = localStorage.getItem('token')
  //   const headers = {
  //     Authorization: `Bearer ${access_token}`
  //   }
  //   axios
  //     .post(
  //       baseUrl + `qrologic/txnstatus`,
  //       { txn_id, referenceId, userID },
  //       { headers }
  //     )
  //     .then(res => {
  //       const icon = res.data?.status == 'SUCCESS' ? 'success' : 'danger'
  //       const title = res.data?.message

  //       profle()
  //       Swal.fire({
  //         title: title,
  //         icon: icon,
  //         confirmButtonText: 'OK'
  //       })
  //     })
  //     .catch(e => {
  //       if (e.response.status == 401) {
  //         localStorage.removeItem('token')
  //         localStorage.removeItem('token')
  //         window.location.reload()
  //       }
  //     })
  // }

  const checkqrologic = async (txn_id, referenceId, userID) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
  try {
    const res = await apiRequest( `qrologic/txnstatus`,"POST",
        { txn_id, referenceId, userID },headers)
        const icon = res.data?.status == 'SUCCESS' ? 'success' : 'danger'
        const title = res.data?.message

        profle()
        Swal.fire({
          title: title,
          icon: icon,
          confirmButtonText: 'OK'
        })
  } catch (e) {
    if (e.response.status == 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('token')
      window.location.reload()
    }
  } finally {
    // setLoading(false)
  }
}


  // const checkrazorpaypayout = (txn_id, referenceId) => {
  //   const access_token = localStorage.getItem('token')
  //   const headers = {
  //     Authorization: `Bearer ${access_token}`
  //   }
  //   axios
  //     .post(
  //       baseUrl + `razorpaypayoutscheck/response`,
  //       { txn_id, referenceId },
  //       { headers }
  //     )
  //     .then(res => {
  //       const icon = res.data?.status == 'SUCCESS' ? 'success' : 'danger'
  //       const title =
  //         res.data?.status == 'SUCCESS'
  //           ? 'Withdraw successfully'
  //           : 'Transaction Proccessing or Failed'

  //       profle()
  //       Swal.fire({
  //         title: title,
  //         icon: icon,
  //         confirmButtonText: 'OK'
  //       })
  //     })
  //     .catch(e => {
  //       if (e.response.status == 401) {
  //         localStorage.removeItem('token')
  //         localStorage.removeItem('token')
  //         window.location.reload()
  //       }
  //     })
  // }

  const checkrazorpaypayout = async (txn_id, referenceId) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
  try {
    const res = await apiRequest(`razorpaypayoutscheck/response`,"POST",
      { txn_id, referenceId },headers)
      const icon = res.data?.status == 'SUCCESS' ? 'success' : 'danger'
      const title =
        res.status == 'SUCCESS'
          ? 'Withdraw successfully'
          : 'Transaction Proccessing or Failed'

      profle()
      Swal.fire({
        title: title,
        icon: icon,
        confirmButtonText: 'OK'
      })
  } catch (e) {
    if (e.response.status == 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('token')
      window.location.reload()
    }
  } finally {
    // setLoading(false)
  }
}




  // const checkkvmPayPayment = (txn_id,referenceId) => {
  //   setLoading(true)
  //   const access_token = localStorage.getItem('token')
  //   const headers = {
  //       Authorization: `Bearer ${access_token}`,
  //     };
  //     axios
  //       .post(
  //         baseUrl + `kvmpay-payout-status`,
  //         { txn_id,referenceId :txn_id},
  //         { headers }
  //       )
  //     .then(res => {
  //   setLoading(false)
  //   Swal.fire({
  //     title: res.data?.status === 'success'  ? 'Success' : 'Error',
  //     text: res.data?.message,
  //     icon: res.data?.status === 'success' ? 'success' : 'error' // Changed 'danger' to 'error'
  //   });
  //       profle()
  //     })
  //     .catch(e => {
  //   setLoading(false)
  //       if (e.response.status == 401) {
  //         localStorage.removeItem('token')
  //         localStorage.removeItem('token')
  //         window.location.reload()
  //       }
  //     })
  // }

  const checkMyPayPayment = async (txn_id,referenceId) => {
    setLoading(true)
    const access_token = localStorage.getItem('token')
    const headers = {
        Authorization: `Bearer ${access_token}`,
      };
  try {
    const res = await apiRequest (`mypay-withdraw-status?ExternalId=${referenceId}`,"GET",null,headers)
    setLoading(false)
    Swal.fire({
      title: res.data?.status === 'success'  ? 'Success' : 'Error',
      text: res.data?.message,
      icon: res.data?.status === 'success' ? 'success' : 'error' // Changed 'danger' to 'error'
    });
        profle()
     
  } catch (e) {
    setLoading(false)
    if (e.response.status == 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('token')
      window.location.reload()
    }
  
  } finally {
    // setLoading(false)
  }
}

const imageopen = (image) => {
    Swal.fire({
      title: "Pay Qr Code",
      text: "",
      imageUrl: baseUrl+`/${image}`,
      imageWidth: 400,
      imageHeight: 300,
      imageAlt: "Custom image"
    })
  }
  const dateFormat = e => {
    const date = new Date(e)
    const newDate = date.toLocaleString('default', {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
      minute: 'numeric'
    })
    return newDate
  }

  let currentTime = Date.now()

  useEffect(() => {
    profle()
  }, [pageNumber, limit, searchList, searchType, findByStatus])

  if (user == undefined) {
    return null
  }
  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={'Loading Please Wait'}
            color={'#FFFFFF'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card'>
            <div className='card-body text-light table_bg'>
              <h4 className=' dashboard_heading'>withdrawal History</h4>
              <select
                className='form-control col-sm-1 m-1 bg-dark text-light'
                id='pagelimit'
                name='pagelimit'
                onChange={setpageLimit}
              >
                <option value='10'>Set limit</option>
                <option value='20'>20</option>
                <option value='50'>50</option>
                <option value='100'>100</option>
                <option value='500'>500</option>
              </select>

              {/* searching */}
              <div className='row'>
                <select
                  className='form-control col-sm-3 m-2'
                  id='searchType'
                  name='searchtype'
                  onChange={e => setSearchType(e.target.value)}
                >
                                      <option value='Phone'>Phone</option>

                  <option value='Name'>Name</option>
                  <option value='Phone'>Phone</option>
                  <option value='account_number'>Ac No.</option>
                  <option value='upiId'>Upi Id</option>
                  <option value='amount'>Amount</option>
                </select>
                <input
                  type='text'
                  placeholder='Search...'
                  className='form-control col-sm-4 m-2'
                  onChange={searchHandler}
                />
                <h5>Or</h5>
                <select
                  className='form-control col-sm-3 m-2'
                  id='findByStatus'
                  name='findByStatus'
                  onChange={searchByStatus}
                >
                  <option value='0'>Search Status</option>
                  <option value='SUCCESS'>Success</option>
                  <option value='Pending'>Pending</option>
                  <option value='pending'>pending</option>
                  <option value='none'>Proccessing</option>
                  <option value='reject'>Reject</option>
                  <option value='FAILED'>Failed</option>
                </select>
              </div>

              <div className='table-responsive'>
                <table className='table text-light'>
                  <thead>
                    <tr>
                      <th>#</th>
                         {
                          id =="6931311e30989ed52eebce14" ?
                      <th> ID</th> : ""}
                      <th> Phone</th>
                      <th> User</th>
                      <th>Type</th>
                      <th>Qr Code</th>
                      <th> Amount </th>
                      <th> Status </th>
                      <th> Reason </th>
                      <th> Action By </th>
                      <th> Time </th>
                    </tr>
                  </thead>

                  <tbody>
                    {user &&
                      user.map((data, key) => {
                        let currentTime = Date.now()
                        let gameCreatedAt = new Date(data?.createdAt).getTime()
                        return (
                          <tr>
                            <td>{key + 1}</td>
                               {
                          id =="6931311e30989ed52eebce14" ?
                            <td>{data?._id}</td> : ""}
                            <td>
                            
                              
                        {admindata?.user?.user_type == 'Admin' ||
                        admindata?.user?.updateLegalData === true ? (
                          <td>{data.User_id?.Phone}</td>
                        ) : (
                          <td>{`${
                            '********' + data.User_id?.Phone.toString().slice(-2)
                          }`}</td>
                        )}
                            
                            </td>
                            <td>
                              {data?.User_id && (
                                <Link
                                  className='btn btn-sm btn-outline-info'
                                  to={`/user/view_user/${data?.User_id._id}`}
                                >
                                   {
                                  data.User_id?.Red_zone == true ?
                                <span className="text-danger">
                                {data.User_id.Name}
                                </span>
                                :
                                <span>
                                {data.User_id.Name}
                                </span>
}
                                </Link>
                              )}
                            </td>
                           
                           
                             <td>
                              <span className='pl-2'>{data?.Withdraw_type}</span>
                            </td>
                            <td>
                          <img src={baseUrl+`/${data.paymentImage}`} 
                          onClick={() => imageopen(data.paymentImage)}
                         onError={(e) => {
          e.target.onerror = null;
          e.target.src = "https://static.thenounproject.com/png/504708-200.png";
        }}
                          />
                        </td>
                            
                            <td>{data?.amount}</td>
                            <td className='font-weight-bold text-success'>
                              {data?.status === 'none'
                                ? 'Proccessing'
                                : data?.status}
                            </td>
                             <td>
                            
                                <span className='pl-2'>
                                  {data?.txn_msg??"----"}
                                </span>
                            
                            </td>
                            <td>
                             {data?.action_by?.Name}
                            </td>
                            <td>{dateFormat(data?.createdAt).split(',')[0]}</td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>

              <div className='mt-4'>
                <ReactPaginate
                  previousLabel={'Previous'}
                  nextLabel={'Next'}
                  breakLabel={'...'}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination justify-content-center'}
                  pageClassName={'page-item'}
                  pageLinkClassName={'page-link'}
                  previousClassName={'page-item'}
                  previousLinkClassName={'page-link'}
                  nextClassName={'page-item'}
                  nextLinkClassName={'page-link'}
                  breakClassName={'page-item'}
                  breakLinkClassName={'page-link'}
                  activeClassName={'active'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <AgentHistory /> */}
    </>
  )
}

export default SucWithdraw
